import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import TableAllProject from '../tableAllProject/TableAllProject'
import { useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import { getContractChange } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function ContractChange({ isSetting, isShow, onSettingChange, dashboradName }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  let history = useHistory()

  useEffect(() => {
    handelGetSchemaDashboard(5, 1)
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getContractChange(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('getContractStatusWait => ', response)
      if (response) {
        response.projectStatusText = response.projectStatusText
      }

      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onMutiSubmit = (selectList) => {
    // console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')
    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (id) => {
    sessionStorage.setItem('projectId', id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.contract.contractChangeForm}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {isSetting && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={dashboradName}
              checked={isShow}
            />
          )}

          <TableAllProject
            schema={schema}
            subName={{ enable: true }}
            muti={{ enable: false, buttonText: `ไปยังการ${schema?.mutiButtonText || 'กลั่นกรอง'}` }}
            single={{
              enable: true,
              buttonText: schema?.buttonText || 'กลั่นกรอง',
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMutiSubmit={onMutiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            hiddenColStatus={true}
            searchRows={{ enable: true }}
            onSearchProject={handelGetSchemaDashboard}
            showContractNo={true}
          ></TableAllProject>
        </>
      )}
    </>
  )
}
